import { NavLink, NavItem } from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const NavItemContainer = ({to, icon, title, mobNavClose, className, suffix, suffixColor}) => {
  return (
    <NavItem className={className}>
      <NavLink tag={Link} to={to} onClick={mobNavClose} className="gap-2">
        <span className="sidebarIcon d-flex align-items-center ">{icon}</span>
        <span className="hide-mini w-100">
          <div className="d-flex align-items-center">
            <span>{title}</span>
            <span className={`badge ms-auto ${suffixColor}`}>{suffix}</span>
          </div>
        </span>
      </NavLink>
    </NavItem>
  );
};
NavItemContainer.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.node,
  toggle: PropTypes.func,
  className: PropTypes.string,
  suffix: PropTypes.any,
  suffixColor: PropTypes.string,
};

export default NavItemContainer;
